import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Collapse, Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { ArrowDown, ArrowUp } from 'components/common/icons'

const useStyles = makeStyles(theme => ({
  disabled: {
    color: 'var(--text-color-62)'
  },
  bottomBorder: {
    paddingBottom: 10,
    borderBottom: '1px solid var(--border-color-2)'
  }
}))

const AISuggestionSection = ({
  title,
  completedTitle,
  icon,
  children,
  shouldDisplayBorder = false,
  wasActionCompleted = false
}) => {
  const classes = useStyles()

  const [isCollapsed, setIsCollapsed] = useState()

  return (
    <Grid
      container
      direction="column"
      className={`${wasActionCompleted && shouldDisplayBorder ? classes.bottomBorder : ''}`}
      spacing={1}
    >
      <Grid item className={classes.divider}></Grid>
      <Grid item>
        <Grid
          container
          alignItems="center"
          spacing={1}
          style={{ cursor: 'pointer' }}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {icon && !wasActionCompleted && <Grid item>{icon}</Grid>}
          <Grid item>
            <DazzedParagraph14 bold className={`${wasActionCompleted ? classes.disabled : ''}`}>
              {wasActionCompleted ? completedTitle : title}
            </DazzedParagraph14>
          </Grid>
          {!wasActionCompleted && <Grid item>{!isCollapsed ? <ArrowUp /> : <ArrowDown />}</Grid>}
        </Grid>
      </Grid>
      {!wasActionCompleted && (
        <Collapse in={!isCollapsed}>
          <Grid item>{children}</Grid>
        </Collapse>
      )}
    </Grid>
  )
}

export default AISuggestionSection
